import ResponsiveMap from "components/ResponsiveMap/ResponsiveMap"
export default ResponsiveMap
